export default __webpack_public_path__ + "static/03-02-analysis-class-wide-a1120b38bf8381d3e802f14e712d28ba.mp4";